<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Edit {{po.number}}</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help
                            you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="partner">Select
                                    Partner</label>
                                <div class="col-sm-9">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('partner')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="partners"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchSellers"
                                            class="form-control"
                                            data-vv-as="partner"
                                            id="partner"
                                            label="partner"
                                            name="partner"
                                            open-direction="bottom"
                                            placeholder="Search Partners"
                                            track-by="id"
                                            v-model="po.seller"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.biz_name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.biz_name }}</h5>
                                                    <h6>{{ props.option.line1}}</h6>
                                                    <h6>{{ props.option.city+', '+ props.option.country}}</h6>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="afterList">
                                            <div class="col-xs-12">
                                                <router-link :to="{name: 'addseller'}"
                                                             class="btn btn-block btn-lg btn-outline-success">
                                                    <i class="fa fa-plus-circle"></i>&nbsp;Add Customer
                                                </router-link>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{
                                        errors.first('partner') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="contract">Select Contract</label>
                                <div class="col-sm-5">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('contract')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="contracts"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchContracts"
                                            class="form-control"
                                            data-vv-as="contract"
                                            id="contract"
                                            label="contract"
                                            @input="setContract"
                                            name="contract"
                                            open-direction="bottom"
                                            placeholder="Search Contract"
                                            track-by="id"
                                            v-model="contract"
                                            v-validate="">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.contract_number }} - {{props.option.type}} - {{ props.option.counterparty.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.contract_number }}</h5>
                                                    <h5>{{ props.option.type }}</h5>
                                                    <h5>{{ props.option.counterparty.name }}</h5>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="afterList">
                                            <div class="col-xs-12">
                                                <router-link :to="{name: 'newcontractstep1'}" class="btn btn-block btn-lg btn-outline-success">
                                                    <i class="fa fa-plus-circle"></i>&nbsp;Add Contract
                                                </router-link>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{ errors.first('partner') }}</div>
                                </div>
                                <div class="col-sm-1 text-center p-t-10 col-form-label"> OR</div>
                                <div class="col-sm-3">
                                    <input type="text"
                                           class="form-control"
                                           @change="setContractNo"
                                           v-model="po.contract_number"
                                           name="contract_number"
                                           placeholder="Add Contract Number"
                                           style="height: 42px;">
                                </div>
                            </div>

                            <div class="form-group row" v-for="(good, index) in po.goods">
                                <label :for="'commodity_id'+index"
                                       class="col-sm-2 text-right control-label col-form-label">Good/Service</label>
                                <!-- Good/Service -->
                                <div class="col-sm-3">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('goodsservice')}"
                                                 :clear-on-select="false"
                                                 :close-on-select="true"
                                                 :hide-selected="true"
                                                 :internal-search="false"
                                                 :limit="3"
                                                 :loading="isLoading"
                                                 :max-height="600"
                                                 :options="goods"
                                                 :options-limit="300"
                                                 :searchable="true"
                                                 :show-no-results="false"
                                                 @input="setUnit(good)"
                                                 @search-change="getGoodsServices"
                                                 class="form-control"
                                                 data-vv-as="goodsservice"
                                                 id="goodsservice"
                                                 label="goodsservice"
                                                 name="goodsservice"
                                                 open-direction="bottom"
                                                 placeholder="Search Goods/Service"
                                                 selectLabel=""
                                                 track-by="id"
                                                 v-model="good.good"
                                                 v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.name }} - {{props.option.variety}}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.name }}</h5>
                                                    {{props.option.variety}}
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('goodsservice')">{{
                                        errors.first('goodsservice') }}
                                    </div>
                                </div>
                                <!-- Quantity -->
                                <div class="col-sm-2 p-l-0 p-r-0">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                               :id="'quantity'+index"
                                               :name="'quantity'+index"
                                               class="form-control"
                                               data-vv-as="quantity"
                                               placeholder="Quantity"
                                               style="height: 42px; width: calc(100% - 70px)"
                                               type="number"
                                               step="any"
                                               v-model="good.quantity"
                                               v-validate="'required'">
                                        <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                               :value="good.unit.symbol" class="form-control"
                                               disabled>
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('quantity'+index)">{{
                                        errors.first('quantity'+index) }}
                                    </div>
                                </div>
                                <!-- Rate -->
                                <div class="col-sm-2 p-r-0">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                               :value="currency" class="form-control"
                                               disabled>
                                        <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                               :id="'rate'+index"
                                               :name="'rate'+index"
                                               class="form-control"
                                               data-vv-as="rate"
                                               placeholder="Rate"
                                               step="any"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               v-model="good.rate"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('rate'+index)">{{ errors.first('rate'+index) }}
                                    </div>
                                </div>
                                <!-- Tax -->
                                <div class="col-sm-2">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('tax'+index)}"
                                               :id="'tax'+index"
                                               :name="'tax'+index"
                                               class="form-control"
                                               data-vv-as="tax"
                                               placeholder="Tax"
                                               step="any"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               v-model="good.tax"
                                               v-validate="'min_value:0'">
                                        <input :class="{'is-invalid': submitted && errors.has('tax'+index)}"
                                               class="form-control" disabled
                                               value="%">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('tax'+index)">{{ errors.first('tax'+index) }}
                                    </div>
                                </div>

                                <div class="col-sm-1">
                                    <div class="form-group button-group">
                                        <button @click="addRow()" class="btn btn-success" type="button"
                                                v-if="index === po.goods.length - 1"><i class="fa fa-plus"></i></button>
                                        <button @click="removeRow(index)" class="btn btn-danger" type="button" v-else><i
                                                class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label"
                                       for="discount">Discount</label>
                                <div class="col-sm-9">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('discount')}"
                                               :value="currency" class="form-control"
                                               disabled>
                                        <input :class="{'is-invalid': submitted && errors.has('audit')}" class="form-control"
                                               data-vv-as="discount"
                                               id="discount"
                                               name="discount"
                                               placeholder="Discount"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               v-model="po.discount"
                                               v-validate="'min_value:0'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('discount')">{{ errors.first('discount') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="audit">Audit
                                    Url</label>
                                <div class="col-sm-9">
                                    <input :class="{'is-invalid': submitted && errors.has('audit')}" class="form-control"
                                           data-vv-as="audit"
                                           id="audit"
                                           name="audit"
                                           placeholder="Audit URL"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="po.audit"
                                           v-validate="'url'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('audit')">{{
                                        errors.first('audit') }}
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label"
                                       for="comments">Comments</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control"
                                              id="comments"
                                              name="comments"
                                              placeholder="Comments"
                                              rows="4"
                                              v-model="po.comments"/>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import UnitSelect from "../../../common/UnitSelect";
    import Multiselect from 'vue-multiselect';
    import CurrencySelect from "../../../../protected/common/CurrencySelect";

    export default {
        name: "EditExpressPurchase",
        components: {UnitSelect, Multiselect, CurrencySelect},
        props: ["poid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                isLoading: false,
                submitted: false,
                expressid: null,
                currency: null,
                partners: [],
                goods: [],
                contracts: [],
                contract: null,
                po: {
                    seller: null,
                    express_id: null,
                    currency_id: null,
                    audit: null,
                    contract_number: null,
                    contract_id: null,
                    comments: null,
                    discount: null,
                    goods: [
                        {
                            good: null,
                            quantity: null,
                            unit: {},
                            rate: null,
                            tax: null
                        }
                    ]
                },
                bkp: null
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                this.expressid      = this.currentOrg.express_id;
                this.po.express_id  = this.currentOrg.express_id;
                this.currency       = this.currentOrg.currency_symbol;
                this.po.currency_id = this.currentOrg.currency_id;
                this.bkp            = JSON.parse(JSON.stringify(this.po));
                await this.getPurchaseOrder();
            },
            async getPurchaseOrder() {
                $(".preloader").fadeIn();
                let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/purchases/${this.poid}`);
                $(".preloader").fadeOut();
                let po = reply.data;
                po.goods.forEach((good, i, arr) => {
                    arr[i] = {
                        id: good.id,
                        good: {id: good.good_id, name: good.name, variety: good.variety},
                        quantity: Number(good.quantity).toFixed(3),
                        unit: good.unit,
                        rate: Number(good.rate).toFixed(2),
                        tax: Number(good.tax).toFixed(2)
                    }
                });

                this.po = po;
                if(po.contract_id) {
                    let ct                          = await this.$http.get(`/express/${this.currentOrg.express_id}/contracts/${po.contract_id}`);
                    this.contract                   = ct.data.contract;
                    this.contract.counterparty.name = this.contract.counterparty.biz_name;
                    this.po.contract_number         = null;
                    this.po.contract_id             = null;
                    this.bkpContract                = JSON.parse(JSON.stringify(this.contract));
                }
                this.bkp = JSON.parse(JSON.stringify(this.po));


            },
            async getGoodsServices(searchText) {
                this.isLoading = true;
                let reply      = await this.$http.get("/express/" + this.expressid + "/purchases/goodsservices/search", {
                    params: {
                        search: searchText,
                        excludeOld: true
                    }
                });
                this.goods     = reply.data;
                this.isLoading = false;
            },
            async searchSellers(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/purchases/sellers/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners  = reply.data;
                    this.isLoading = false;
                } catch(e) {
                    console.log(e);
                }
            },
            setUnit(row) {
                if(row) {
                    row.unit = row.good.unit;
                }
            },
            setCurrency(e) {
                if(e) {
                    this.po.currency = {
                        id: e.id,
                        name: e.name,
                        symbol: e.symbol
                    }
                }
            },
            addRow() {
                this.po.goods.push({
                    good: null,
                    quantity: null,
                    unit: {},
                    rate: null
                });
            },
            removeRow(index) {
                this.po.goods.splice(index, 1);
            },
            async save() {
                try {
                    $(".preloader").fadeIn();
                    let po = {
                        express_id: this.po.express_id,
                        seller_id: this.po.seller.partner_id,
                        currency_id: this.po.currency_id,
                        audit: this.po.audit,
                        contract_number: this.contract?this.contract.contract_number:this.po.contract_number,
                        contract_id: this.contract?this.contract.id:null,
                        comments: this.po.comments,
                        attachments: [],
                        discount: this.po.discount ? Number(this.po.discount) : 0,
                        goods: []
                    }

                    this.po.goods.forEach(row => {
                        po.goods.push({
                            id: row.id,
                            good_id: row.good.id,
                            quantity: Number(row.quantity),
                            unit_id: row.unit.id,
                            rate: Number(row.rate),
                            tax: row.tax ? Number(row.tax) : 0
                        })
                    });

                    let reply = await this.$http.post(`/express/${this.currentOrg.express_id}/purchases/${this.po.id}`, po);
                    $(".preloader").fadeOut();
                    this.$toastr('success', 'New Purchase order has been modified successfully.', 'Purchase order Added');
                    this.$router.push({name: "expresspurchases"});
                } catch(e) {
                    console.error(e);
                    $(".preloader").fadeOut();
                }
            },
            handleSubmit() {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            reset() {
                this.submitted = false;
                this.contract  = JSON.parse(JSON.stringify(this.bkpContract));
                this.po        = JSON.parse(JSON.stringify(this.bkp));
            },
            async searchContracts(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/contracts", {
                        params: {
                            number: searchText
                        }
                    });
                    this.contracts = reply.data.contracts;
                    this.isLoading = false;
                } catch(e) {
                    console.log(e);
                }
            },
            setContract() {
                this.po.contract_number = null;
            },
            setContractNo() {
                this.contract       = null;
                this.po.contract_id = null;
            }
        }
    }
</script>

<style scoped>
    .form-group .required .control-label:after {
        content: "*";
        color: red;
    }
</style>
